import { userAuthState } from "@/@core/auth"



export const redirects = [
  // Documentation redirect
  {
    path: '/documentation',
    name: 'documentation',
    redirect: '/documentation/feedback/features/01-overview',
  },

  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/app/',
    name: 'app',
    redirect(to) {
      const authState = userAuthState()
      const isLoggedIn = authState.isLoggedIn

      if (!isLoggedIn) return { name: 'app-login', query: to.query }
      
      return { name: 'app-panel' }
    },
  },
  {
    path: '/',
    name: 'index',
    redirect(to) {
      const authState = userAuthState()
      const isLoggedIn = authState.isLoggedIn

      if (!isLoggedIn) return { name: 'app-login', query: to.query }
      
      return { name: 'app-panel' }
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/pages/app/ForgotPassword.vue'),
    meta: { public: true },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/pages/app/ResetPassword.vue'),
    meta: { public: true },
    props: route => ({ 
      token: route.query.token, 
      email: route.query.email, 
    }),
  },
]

export const routes = [
  // Global Settings Routes
  {
    path: '/app/global/users/:id/:tab',
    name: 'app-global-user-tab',
    component: () => import('@/pages/app/global/users/user.vue'),
    meta: {
      name: 'user-update',
      navActiveLink: 'users',
      subject: 'master.user',
      action: 'update',
    },
  },
  {
    path: '/app/global/users/add',
    name: 'app-user-add',
    component: () => import('@/pages/app/global/users/user.vue'),
    meta: {
      name: 'user-create',
      navActiveLink: 'users',
      subject: 'master.user',
      action: 'create',
    },
  },
  {
    path: '/app/global/config/add',
    name: 'app-global-config-add',
    component: () => import('@/pages/app/global/config/config.vue'),
    meta: {
      subject: 'config.config',
      action: 'create',
      navActiveLink: 'app-global-config',
    },
  },
  {
    path: '/app/global/config/:id',
    name: 'app-global-config-tab',
    component: () => import('@/pages/app/global/config/config.vue'),
    meta: {
      subject: 'config.config',
      action: 'update',
      navActiveLink: 'app-global-config',
    },
  },
  {
    path: '/app/global/escalation/:escalationType/:departmentId/:categoryId?/:childCategoryId?',
    name: 'app-global-escalation-create-update',
    component: () => import('@/pages/app/global/escalation/create-update.vue'),
    meta: {
      name: 'escalation-create-update',
      navActiveLink: 'app-global-escalation',
      subject: 'configuration.escalation',
      action: 'update',
    },
    props: true,
  },

  // Notification Routes
  {
    path: '/app/feedback/notifications',
    name: 'app-feedback-notifications',
    component: () => import('@/pages/app/common/notifications/index.vue'),
    meta: {
      name: 'notifications',
      navActiveLink: 'app-feedback-notifications',
      module: 'FEEDBACK',
    },
  },

  // Feedback Routes
  {
    path: '/app/feedback/questionnaire/add',
    name: 'app-feedback-question-add',
    component: () => import('@/pages/app/feedback/questionnaire/question.vue'),
    meta: {
      subject: 'master.question',
      action: 'create',
      navActiveLink: 'questionnaire',
    },
  },
  {
    path: '/app/feedback/questionnaire/:id',
    name: 'app-feedback-question-tab',
    component: () => import('@/pages/app/feedback/questionnaire/question.vue'),
    meta: {
      subject: 'master.question',
      action: 'update',
      navActiveLink: 'questionnaire',
    },
  },
  {
    path: '/app/feedback/entry/standard',
    name: 'app-feedback-entry-standard',
    component: () => import('@/pages/app/feedback/entry/index.vue'),
    meta: {
      subject: 'feedback.feedback',
      action: 'create',
    },
  },
  {
    path: '/app/feedback/entry/assorted',
    name: 'app-feedback-entry-assorted',
    component: () => import('@/pages/app/feedback/entry/index.vue'),
    meta: {
      subject: 'feedback.feedback',
      action: 'create',
    },
  },

  // Incident Routes
  {
    path: '/app/incident/entry/:id?',
    name: 'app-incident-entry',
    component: () => import('@/pages/app/incident/incident/entry/index.vue'),
    meta: {
      subject: 'incident.incident',
      action: 'create',
      navActiveLink: 'app-incident-incident',
    },
    props: true,
  },
  {
    path: '/app/incident/view/:id',
    name: 'app-incident-view',
    component: () => import('@/pages/app/incident/incident/entry/view.vue'),
    meta: {
      subject: 'incident.incident',
      action: 'read',
      navActiveLink: 'app-incident-incident',
    },
    props: true,
  },

  // {
  //   path: '/app/incident/rca/investigation/:id',
  //   name: 'app-incident-rca-investigation',
  //   component: () => import('@/pages/app/incident/rca/investigation/index.vue'),
  //   meta: {
  //     navActiveLink: 'app-incident-incident',
  //   },
  //   props: true,
  // },

  {
    path: '/app/incident/rca/view/:id',
    name: 'app-incident-rca-view',
    component: () => import('@/pages/app/incident/rca/view.vue'),
    meta: {
      subject: 'incident.incident_rca',
      action: 'read',
      navActiveLink: 'app-incident-rca',
    },
    props: true,
  },

  {
    path: '/app/incident/master/question/entry/:id?',
    name: 'app-incident-master-question-entry',
    component: () => import('@/pages/app/incident/master/question/entry.vue'),
    meta: {
      navActiveLink: 'app-incident-master-question',
    },
    props: true,
  },
  {
    path: '/app/incident/master/audit/:id/questionnaire',
    name: 'app-incident-master-audit-questionnaire',
    component: () => import('@/pages/app/incident/master/audit/questionnaire.vue'),
    meta: {
      navActiveLink: 'app-incident-master-audit',
    },
    props: true,
  },
  {
    path: '/app/incident/audit/:id/entry',
    name: 'app-incident-audit-entry',
    component: () => import('@/pages/app/incident/audit/entry.vue'),
    meta: {
      navActiveLink: 'app-incident-audit',
    },
    props: true,
  },
  {
    path: '/app/incident/audit/:id/view',
    name: 'app-incident-audit-view',
    component: () => import('@/pages/app/incident/audit/view.vue'),
    meta: {
      navActiveLink: 'app-incident-audit',
    },
    props: true,
  },

  // System Routes
  {
    path: '/invalid-url/:code?/:title?/:description?',
    name: 'invalid-url',
    component: () => import('@/views/misc/invalid-url.vue'),
    meta: {
      layout: 'client',
      public: true,
    },
    props: true,
  },

  //survey
  // {
  //   path: '/app/survey/survey/create',
  //   name: 'app-survey-survey-entry',
  //   component: () => import('@/pages/app/survey/survey/entry.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-survey',
  //     action: 'create',
  //     subject: 'survey.survey',
  //   },
  // },

  // {
  //   path: '/app/survey/:id/entry',
  //   name: 'app-survey-entry-view',
  //   component: () => import('@/pages/app/survey/entry/index.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-survey',
  //     action: 'update',
  //     subject: 'survey.survey',
  //   },
  //   props: true,
  // },
  // {
  //   path: '/app/survey/event/:id/entry',
  //   name: 'app-survey-event-entry-view',
  //   component: () => import('@/pages/app/survey/entry/index.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-survey-event',
  //     action: 'update',
  //     subject: 'survey.survey',
  //   },
  //   props: true,
  // },
  // {
  //   path: '/app/survey/employee/:id/entry',
  //   name: 'app-survey-employee-entry-view',
  //   component: () => import('@/pages/app/survey/entry/index.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-survey-employee',
  //     action: 'update',
  //     subject: 'survey.survey',
  //   },
  //   props: true,
  // },
  // {
  //   path: '/app/survey/schedule/entry',
  //   name: 'app-survey-schedule-entry',
  //   component: () => import('@/pages/app/survey/schedule/entry.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-schedule',
  //     action: 'create',
  //     subject: 'survey.survey_schedule',
  //   },
  // },

  // Survey Routes
  {
    path: '/app/survey/:type/setup/:survey?',
    name: 'app-survey-customer-setup',
    component: () => import('@/pages/app/survey/customer/setup.vue'),
    meta: {
      navActiveLink: 'app-survey-customer-setup',
      subject: "survey.survey",
      action: "create",
    },
  },
  {
    path: '/app/survey/:type/analytics/:survey',
    name: 'app-survey-customer-analytics',
    component: () => import('@/pages/app/survey/customer/analytics.vue'),
    meta: {
      navActiveLink: 'app-survey-customer-analytics',
      subject: "survey.survey",
      action: "read",
    },
  },
  {
    path: '/app/survey/:type/subscriptions/:survey',
    name: 'app-survey-customer-subscriptions',
    component: () => import('@/pages/app/survey/customer/subscriptions.vue'),
    meta: {
      navActiveLink: 'app-survey-customer-subscriptions',
      subject: "survey.survey",
      action: "read",
    },
  },
  {
    path: '/app/survey/collection/:id/view',
    name: 'app-survey-collection-view',
    component: () => import('@/pages/app/survey/collection/view.vue'),
    meta: {
      navActiveLink: 'app-survey-collection-view',
      subject: "survey.survey",
      action: "read",
    },
  },

  {
    path: '/app/survey/collection/:survey/:type/:participant/view',
    name: 'app-survey-collection-customer-view',
    component: () => import('@/pages/app/survey/collection/customer/view.vue'),
    meta: {
      navActiveLink: 'app-survey-collection-customer',
      subject: "survey.survey",
      action: "read",
    },
  },

  // {
  //   path: '/app/survey/survey/:id/questionnaire',
  //   name: 'app-survey-survey-questionnaire',
  //   component: () => import('@/pages/app/survey/survey/questionnaire.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-survey',
  //   },
  //   props: true,
  // },
  // {
  //   path: '/app/survey/entry/event/:id/analytics',
  //   name: 'app-survey-event-analytics',
  //   component: () => import('@/pages/app/survey/analytics/index.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-entry-event',
  //   },
  //   props: true,
  // },
  // {
  //   path: '/app/survey/entry/employee/:id/analytics',
  //   name: 'app-survey-employee-analytics',
  //   component: () => import('@/pages/app/survey/analytics/index.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-entry-employee',
  //   },
  //   props: true,
  // },
  // {
  //   path: '/app/survey/entry/:id/analytics',
  //   name: 'app-survey-analytics',
  //   component: () => import('@/pages/app/survey/analytics/index.vue'),
  //   meta: {
  //     navActiveLink: 'app-survey-entry',
  //   },
  //   props: true,
  // },

  // Care Visit
  {
    path: '/app/care-visit/kiosk-analytics/:id',
    name: 'app-care-visit-kiosk-analytics',
    component: () => import('@/pages/app/care-visit/dashboard/kiosk-analytics.vue'),
    meta: {
      navActiveLink: 'app-care-visit-dashboard',
      name: "Kiosk Analytics",
      subject: "care_visit.menu",
      action: "kiosk",
    },
  },
]

